// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-404-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #0f172a 100%);
  position: relative;
  overflow: hidden;

  font-family: 'Montserrat', sans-serif;
}



.btn-home{
  font-family: 'Montserrat', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  width:fit-content;
  height: 40px;
  background-color: #C39B22;
  color: #000;
  border: 2px solid transparent;
  border-radius: 12px;
  font-size: 1rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  gap: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/PageNotFound/Pagenotfound.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;;EAEhB,qCAAqC;AACvC;;;;AAIA;EACE,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ;AACV","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');\n\n.page-404-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #0f172a 100%);\n  position: relative;\n  overflow: hidden;\n\n  font-family: 'Montserrat', sans-serif;\n}\n\n\n\n.btn-home{\n  font-family: 'Montserrat', sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width:fit-content;\n  height: 40px;\n  background-color: #C39B22;\n  color: #000;\n  border: 2px solid transparent;\n  border-radius: 12px;\n  font-size: 1rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  gap: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
